module.exports = __webpack_public_path__ + "static/media/result_rb_ja.ec365309.jpg";